export enum EProductOrderModeType {
  ImmediateOnly = 0,
  ReservationOnly = 1,
  ImmediateAndReservation = 2,
}
